import gql from 'graphql-tag'

export const GET_CHANNEX_MAPPINGS_QUERY = gql`
  query GetChannexMappings {
    getChannexMappings {
      roomTypes {
        id
        roomCategoryId
        channexRoomTypeId
        pushEnabled
      }
      ratePlans {
        id
        roomCategoryId
        roomTariffId
        channexRatePlanId
        pushEnabled
      }
      localCategories {
        id
        title
      }
      localTariffs {
        id
        title
      }
    }
  }
`
